import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoItsFor } from '../components/WhoItsFor';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#FAF7F2] font-sans selection:bg-[#C9A84C] selection:text-[#1B5E5E]" data-id="element-181">
      <HeroSection data-id="element-182" />
      <HookSection data-id="element-183" />
      <ProblemSection data-id="element-184" />
      <FailedSolutions data-id="element-185" />
      <MechanismSection data-id="element-186" />
      <WhatYouGet data-id="element-187" />
      <WhoItsFor data-id="element-188" />
      <CTASection data-id="element-189" />
      <Footer data-id="element-190" />
    </main>;
}